import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog,
  MatDialogConfig, MatDialogRef
} from '@angular/material/dialog';
import { TagCategoryInfoFragment } from 'generated/graphql';

/**
 * Format of data for the dialog
 */
export interface ApplyTagDialogData {
  campaignId: string;
  targetType: 'Entity' | 'EntityConnection' | 'CalendarEventResponse';
  targetId: string;
  category: TagCategoryInfoFragment;
}

/**
 * Modal to apply a tag to either an Entity or EntityConnection
 * when a tag category is already provided
 */
@Component({
  selector: 'app-apply-tag-dialog',
  templateUrl: './apply-tag.dialog.html'
})
export class ApplyTagDialog {
  public static open(dialog: MatDialog, config: MatDialogConfig<ApplyTagDialogData>) {
    return dialog.open(ApplyTagDialog, { ...config, ...{ disableClose: true } });
  }

  /**
   *
   */
  constructor(
    public dialogRef: MatDialogRef<ApplyTagDialog>,
    @Inject(MAT_DIALOG_DATA) public data: ApplyTagDialogData
  ) {
    if (!['Entity', 'EntityConnection', 'CalendarEventResponse'].includes(data.targetType)) {
      throw new Error('Target Type must be Entity, EntityConnection, or CalendarEventResponse');
    }
  }

  close() {
    this.dialogRef.close();
  }
}
